import { SortTypeEnum } from "@repo/helpers";
import { Column, DateColumn, GridPreLoaded } from "@repo/ui";

import { useRepDisciplineQueries } from "../../../../api/repDisciplineApi";
import { useRepDisciplineContext } from "../../../../contexts/editableItemContext";
import { RepDisciplineHistory } from "../../../../models/repDiscipline";

export default function RepDisciplineHistoryGrid() {
	const { item } = useRepDisciplineContext();
	const { useRepDisciplineHistoryQuery } = useRepDisciplineQueries();
	const { data, loaded, clearQuery } = useRepDisciplineHistoryQuery(item?.repDisciplineId);
	return (
		<GridPreLoaded
			columns={
				[
					new DateColumn("Timestamp", "timestamp").dateOnly().withSortBy(SortTypeEnum.descending),
					new Column("Message", "message"),
					new Column("User Name", "userName"),
				] as Column<RepDisciplineHistory>[]
			}
			keyProperty="repDisciplineHistoryId"
			pageSize={10}
			values={data?.data ?? []}
			loading={!loaded}
			getData={clearQuery}
		/>
	);
}
